import { BaseLinkPreviewObject } from 'owa-link-preview/lib/utils/BaseLinkPreviewObject';
import {
    VideoLinkPreviewObject,
    addPlayButton,
} from 'owa-link-preview/lib/utils/VideoLinkPreviewObject';

export default function addInteractiveElementsForReadingPane(lp: BaseLinkPreviewObject) {
    if (lp.hasOwnProperty('videoPlayer')) {
        addPlayButton(<VideoLinkPreviewObject>lp);
    }
}
